/** 只用于显式启用的开发服务器；生产构建始终使用正常登录会话。 */
export const LOCAL_DEV_AUTH = import.meta.env.DEV && import.meta.env.VITE_LOCAL_DEV_AUTH === 'true';
